(function () {
  'use strict';

  function activate(root, nextTab) {
    var tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (tab) {
      var active = tab === nextTab;
      var panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      if (panel) {
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.zsTabsReady === 'true') return;
    root.dataset.zsTabsReady = 'true';
    var tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(root, tab); });
      tab.addEventListener('keydown', function (event) {
        var nextIndex = null;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        activate(root, tabs[nextIndex]);
        tabs[nextIndex].focus();
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-zs-product-tabs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());
